import React from 'react'
import { injectIntl, WrappedComponentProps } from 'react-intl'

import { NotFound } from '../../components/NotFound'

const NotFoundPage: React.FC<WrappedComponentProps> = ({ intl }) => {
  return <NotFound intl={intl} />
}

export default injectIntl(NotFoundPage)
